<div class="company-detail">
  <nav class="company-detail__breadcrumb" aria-label="Breadcrumb">
    <a routerLink="/admin/companies" class="company-detail__back">← Companies</a>
  </nav>

  <div class="company-detail__state" *ngIf="loading">Loading company…</div>
  <div class="company-detail__state company-detail__state--error" *ngIf="!loading && errorMessage">
    {{ errorMessage }}
  </div>

  <ng-container *ngIf="!loading && !errorMessage && company">
    <header class="company-detail__header">
      <div class="company-detail__logo" aria-hidden="true">
        <img *ngIf="logoUrl() as url" [src]="url" [alt]="''" (error)="onLogoError()" />
        <span *ngIf="!logoUrl()">{{ companyInitials(company.name) }}</span>
      </div>
      <div class="company-detail__identity">
        <h1 class="company-detail__title">{{ company.name }}</h1>
        <p class="company-detail__meta">
          <span>{{ company.email || 'No email on file' }}</span>
          <span
            class="company-detail__pill"
            [class.company-detail__pill--off]="company.is_active === false"
          >
            {{ company.is_active === false ? 'Inactive' : 'Active' }}
          </span>
        </p>
      </div>
    </header>

    <nav class="company-detail__tabs" aria-label="Company sections">
      <a
        *ngFor="let tab of tabs"
        class="company-detail__tab"
        [routerLink]="tab.path"
        routerLinkActive="is-active"
      >
        {{ tab.label }}
      </a>
    </nav>

    <router-outlet></router-outlet>
  </ng-container>
</div>
